
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"24","viewBox":"0 0 21 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.71519 0.542866C2.38265 -0.277158 0.666992 0.681541 0.666992 2.24618V21.7546C0.666992 23.3192 2.38265 24.2779 3.71519 23.4579L19.5658 13.7037C20.8348 12.9227 20.8348 11.078 19.5658 10.2971L3.71519 0.542866Z","fill":"currentColor"}})])
          )
        }
      }
    